// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__1Q9eB","data":"Card_data__1sYkQ","heading":"Card_heading__4iJ05"};